function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-fill-pink",
  d: "M18.27,12.31c2.22-1.02,3.68-3.24,3.68-5.74c0-1.64-1.33-2.97-2.97-2.97h-0.64V3.07c0-0.55-0.45-1-1-1H6.66 c-0.55,0-1,0.45-1,1V3.6h-0.6c-1.64,0-2.97,1.33-2.97,2.97c0,2.48,1.44,4.7,3.64,5.73c0.3,2.08,1.61,3.82,3.4,4.73v2.95H7.29 c-0.55,0-1,0.45-1,1s0.45,1,1,1h1.84h5.74h1.84c0.55,0,1-0.45,1-1s-0.45-1-1-1h-1.84v-2.95C16.68,16.11,17.99,14.37,18.27,12.31z  M18.99,5.6c0.54,0,0.97,0.43,0.97,0.97c0,1.34-0.61,2.58-1.61,3.38V5.6H18.99z M5.06,5.6h0.6v4.32C4.68,9.11,4.09,7.89,4.09,6.57 C4.09,6.03,4.52,5.6,5.06,5.6z M7.66,11.5c0-0.04,0-0.09,0-0.13v-7.3h8.69v7.3c0,0.04,0,0.08,0,0.12c0,0.01,0,0.02,0,0.03 l-0.02,0.17c-0.16,2.26-2.04,4.01-4.32,4.01C9.67,15.71,7.77,13.89,7.66,11.5z M11.13,19.97V18h1.74v1.97H11.13z"
}));

var SvgIconCompetition = function SvgIconCompetition(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCompetition, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_competition.30c3c4a5.svg";
export { ForwardRef as ReactComponent };